import { ReadyToPackProject } from '../../types';

// Mock data: proyectos en estado listo-para-embalar (ERP-55: simula respuesta de /api/projects/ready-to-pack)
export const MOCK_EMBALAJE: ReadyToPackProject[] = [
  {
    id: 10,
    reference: 'PRJ-010',
    title: 'Camisetas DTF Temporada Verano',
    description: 'Lote 200 unidades tallas S/M/L. Caja individual por unidad.',
    status: 'in_progress',
    priority: 80,
    currentDepartment: 'embalaje',
    client: { id: 1, name: 'Moda Express', company: 'Moda Express SL' },
    dueDate: new Date(Date.now() + 1 * 86400000).toISOString(), // mañana — urgente
    createdAt: new Date(Date.now() - 5 * 86400000).toISOString(),
    progress: 80,
    steps: [
      { id: 1, department: 'gestor',   orderIndex: 0, status: 'done',        data: {} },
      { id: 2, department: 'dtf',      orderIndex: 1, status: 'done',        data: {} },
      { id: 3, department: 'almacen',  orderIndex: 2, status: 'done',        data: {} },
      { id: 4, department: 'embalaje', orderIndex: 3, status: 'in_progress', data: {} },
    ],
  },
  {
    id: 11,
    reference: 'PRJ-011',
    title: 'Flyers Corporativos Q3 — Edición Premium',
    description: 'Flyers A5 plastificados mate, 1000 unidades. Embalar en grupos de 100.',
    status: 'in_progress',
    priority: 60,
    currentDepartment: 'embalaje',
    client: { id: 2, name: 'Tech Startup SL' },
    dueDate: new Date(Date.now() - 1 * 86400000).toISOString(), // ayer — VENCIDO
    createdAt: new Date(Date.now() - 8 * 86400000).toISOString(),
    progress: 90,
    steps: [
      { id: 5, department: 'gestor',    orderIndex: 0, status: 'done',        data: {} },
      { id: 6, department: 'financiero',orderIndex: 1, status: 'done',        data: {} },
      { id: 7, department: 'imprenta',  orderIndex: 2, status: 'done',        data: {} },
      { id: 8, department: 'embalaje',  orderIndex: 3, status: 'in_progress', data: {} },
    ],
  },
  {
    id: 12,
    reference: 'PRJ-012',
    title: 'Roll-ups Feria Internacional 2026',
    description: '6 roll-ups 80x200cm. Embalar en estuches protectores individuales.',
    status: 'in_progress',
    priority: 40,
    currentDepartment: 'embalaje',
    client: { id: 3, name: 'Expo & Trade' },
    dueDate: new Date(Date.now() + 4 * 86400000).toISOString(),
    createdAt: new Date(Date.now() - 3 * 86400000).toISOString(),
    progress: 75,
    steps: [
      { id: 9,  department: 'gestor',   orderIndex: 0, status: 'done',        data: {} },
      { id: 10, department: 'imprenta', orderIndex: 1, status: 'done',        data: {} },
      { id: 11, department: 'almacen',  orderIndex: 2, status: 'done',        data: {} },
      { id: 12, department: 'embalaje', orderIndex: 3, status: 'in_progress', data: {} },
    ],
  },
  {
    id: 13,
    reference: 'PRJ-013',
    title: 'Bolsas Personalizadas Boda García',
    description: '50 bolsas kraft con lazo dorado. Embalaje delicado, una por una.',
    status: 'in_progress',
    priority: 20,
    currentDepartment: 'embalaje',
    client: { id: 4, name: 'Eventos Premium' },
    dueDate: new Date(Date.now() + 6 * 86400000).toISOString(),
    createdAt: new Date(Date.now() - 2 * 86400000).toISOString(),
    progress: 70,
    steps: [
      { id: 13, department: 'gestor',   orderIndex: 0, status: 'done',        data: {} },
      { id: 14, department: 'almacen',  orderIndex: 1, status: 'done',        data: {} },
      { id: 15, department: 'embalaje', orderIndex: 2, status: 'in_progress', data: {} },
    ],
  },
];
